<template>
  <v-card>
    <v-card-title>
      Materiais Compartilhado
    </v-card-title>
    <v-card-text v-show="!showCard">
      <div class="text-center ma-12" align="center">
        <v-progress-circular
          class=""
          :indeterminate="true"
          :rotate="0"
          :size="128"
          value="Loading"
          :width="8"
          color="light-blue"
          >{{ "Loading" }}</v-progress-circular
        >
      </div>
    </v-card-text>
    <v-card-subtitle>
      Total de {{ total_materiais }} Materiais Compartilhados
    </v-card-subtitle>
    <GraphicColumn
      v-if="showCard"
      :categories="categories"
      :titleY="titleY"
      :titleX="titleX"
      :chartSeries="chartSeries"
    />
    <GraphicLine
      v-if="false"
      :categories="categories"
      :titleY="titleY"
      :titleX="titleX"
      :chartSeries="chartSeries"
    />
  </v-card>
</template>

<script>
import { mapGetters } from "vuex";
import firebase from "@/plugins/firebase";
export default {
  components: {
    GraphicColumn: () => import("./GraphicColumn"),
    GraphicLine: () => import("./GraphicLine")
  },

  data() {
    return {
      categories: [],
      titleY: "Materiais",
      total_materiais: 0,
      titleX: "Empresa",
      chartSeries: [
        {
          color: "#ea4335",
          data: [],
          name: "Materiais",
          showInLegend: true
        },
        {
          name: "Percentual",
          data: [],
          dataLabels: {
            enabled: true,
            format: "{point.y:.2f}%",
            x: 5
          },
          tooltip: {
            valueSuffix: "%"
          }
        }
      ],
      date_init: "",
      date_end: "",
      isCompany: false,
      company: [],
      showCard: false
    };
  },
  methods: {
    async init() {
      var dataValue = [];
      var dataTwoColumn = [];
      var dataCategorie = [];
      const callDate = this.getFilter;
      this.date_init = callDate.date[0];
      this.date_end = callDate.date[1];
      this.company = callDate.empresas;
      this.isCompany = callDate.withCompany;

      const app_analytics = firebase
        .functions()
        .httpsCallable("app_analytics/materiaisCompartilhado");
      await app_analytics({
        date_init: this.date_init,
        date_end: this.date_end,
        isCompany: this.isCompany,
        company: this.company
      })
        .then(result => {
          this.total_materiais = result.data[0].total_all;
          var tmp = [];
          this.getEmpresas.forEach((e, c) => {
            tmp = [];
            tmp = result.data.filter(a => {
              return a.empresa == e.cnpj;
            });
            dataValue.push(tmp.length > 0 ? Number(tmp[0].total_simulado) : 0);
            dataTwoColumn.push(tmp.length > 0 ? Number(tmp[0].percentual) : 0);
            dataCategorie.push(e.apelido);
          });
        })
        .catch(erro => {
          console.log(erro);
        });

      Promise.all(dataValue, dataCategorie).then(a => {
        this.showCard = !this.showCard;
        this.categories = dataCategorie;
        this.chartSeries[0].data = dataValue;
        this.chartSeries[1].data = dataTwoColumn;
      });
    }
  },
  created() {
    this.init();
  },
  computed: {
    ...mapGetters("appAnalytics", ["getFilter"]),
    ...mapGetters(["getEmpresas"])
  },
  watch: {
    getFilter(m, v) {
      this.showCard = false;
      this.init();
    }
  }
};
</script>

<style lang="scss"></style>
